module.exports = __webpack_public_path__ + "static/media/filler1.6a7988c4.jpg";